import React from 'react';
import { Button, Card, Col, Row, Space, Spin, Switch } from 'antd';
import StarSvg from '../../assets/images/StarSvg';
import HeartSvg from '../../assets/images/heartSvg';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import ViewTableSvg from '../../assets/images/ViewTable';
import PaginationFetchData from '../data-table/PaginationFetchData';

const FashionCard = ({
    magazineData, setLoading, loading, t,
    tableParams, setTableParams, tableSettings, navigate, 
    hadleUpdateMagazine, deleteMagazineData, handleShowMagazine
}) => {
    return (
        <Spin spinning={loading}>
            <div className='row'>
                {
                    magazineData.map((mag, index) => (
                        <div className='mb-4 col-sm-12 col-md-4 col-lg-4'>
                            <Card className='w-100 h-100 cusCard'>
                                <Row>
                                    <Col md={8}>
                                        <img
                                            src={mag && mag.picUrl}
                                            alt="Magazine Cover"
                                            style={{
                                                height: "133px",
                                                width: "100px",
                                                objectFit: "cover",
                                                borderRadius: "6px",
                                            }}
                                        />
                                    </Col>
                                    <Col md={16}>
                                        <Row>
                                            <Col md={24}>{t(mag.title)}</Col>
                                            <Col md={24} className='mt-2'>
                                                {t(mag.year)}
                                            </Col>
                                            <Col md={24} className='mt-2 me-3'>
                                                {mag?.description || ""}
                                            </Col>
                                            <Col md={24} className='mt-2'>
                                                <Space size="middle">
                                                <Switch checked={mag.status} onChange={() => hadleUpdateMagazine(mag)} />
                                                    <span style={{ cursor: "pointer" }} onClick={() => navigate(`/fashion/upload/${mag.fashionId}`)}>
                                                        <EditTableSvg />
                                                    </span>
                                                    <span style={{ cursor: "pointer" }} onClick={() => deleteMagazineData(mag)}>
                                                        <DeleteTableSvg />
                                                    </span>
                                                    <span style={{ cursor: "pointer" }}onClick={() => handleShowMagazine(mag)}>
                                                        <ViewTableSvg />
                                                    </span>
                                                </Space>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    ))
                }
                <PaginationFetchData
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    data={magazineData}
                    columns={tableSettings.columns}
                    loading={loading}
                    setLoading={setLoading}
                />
            </div>
        </Spin>
    );
};

export default FashionCard;
